define('logitail_shippingandreturnspdp_shippingandreturnspdp.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('logitail_shippingandreturnspdp_shippingandreturnspdp', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/logitail/ShippingandReturnsPdp/1.0.0/', 'extensions/logitail/ShippingandReturnsPdp/1.0.0/', Handlebars);
});